module.exports = __webpack_public_path__ + "static/media/dot_0FBB58.41e5ae71.svg";